import { useState, useEffect, useContext } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import useTranslator from "../../hooks/useTranslator";
import i18next from "i18next";
import constants from "../../Utils/constants";
import AuthContext from "../../context/auth/AuthContext";
import TenantContext from "../../context/tenant/TenantContext";
import "react-toastify/dist/ReactToastify.css";
import { haveValue, toast } from "../../helper/common";
import axios from "axios";
import { useCookies } from "react-cookie";
import LandLordContext from "../../context/landlord/LandLordContext";
import Logo from "../../assets/img/skor-white-logo.svg";
import Flag from "../../assets/img/flag.svg";

const SelectUserType = () => {
  const { _t } = useTranslator();
  const [cookies, setCookie, removeCookie] = useCookies(["sharedProfileLink"]);
  const navigate = useNavigate();
  const queryParameters = new URLSearchParams(window.location.search);
  const { workspace_slug } = useParams();
  const logincode = queryParameters.get("code");
  const workspaceUuid = queryParameters.get("wid");
  const { hash, pathname } = useLocation();

  const { setUserType, toggleLogin, loadUser, setLoading } =
    useContext(AuthContext);
  const { shareProfile } = useContext(TenantContext);
  const { getWorkspaceDetailsFromSlug } = useContext(LandLordContext);
  const [currentScreen, setCurrentScreen] = useState("selectUserType");
  const [currentLang, setCurrentLang] = useState(
    localStorage.getItem("i18nextLng")?.toLowerCase() || "en-us"
  );
  const [isGuarantor, setIsGuarantor] = useState(false);
  const [userLogin, setUserLogin] = useState({
    _id: null,
    email: "",
    password: "",
    confirmPassword: "",
    type: "tenant",
    checkedTenant: true,
    checkedLandlord: false,
    user_type:
      window.location.hostname === "alquilatuhogar.skortorent.com"
        ? constants.MACC
        : constants.SKOR,
    checked: false,
    qrCode_signup: false,
    analysisCompleted: true,
    requestProfileLink: null,
  });
  const [companyLogo, setCompanyLogo] = useState(null);

  const [selectedType, setSelectedType] = useState("tenant");
  const authContext = useContext(AuthContext);
  const { changeUserLng } = authContext;

  useEffect(() => {
    if (pathname === "/tenant/auth") {
      handleUsertypeFromUrl("tenant");
      setCurrentScreen("selectUserEmail");
    } else if (pathname === "/landlord/auth") {
      handleUsertypeFromUrl("landlord");
      setCurrentScreen("selectUserEmail");
    } else if (pathname === "/guarantor/auth") {
      setIsGuarantor(true);
      handleUsertypeFromUrl("tenant");
      setCurrentScreen("selectUserEmail");
    } else if (pathname === "/guarantor/auth") {
      setCurrentScreen("selectUserType");
    }
  }, [pathname]);

  useEffect(() => {
    if (
      haveValue(cookies?.requestProfileLink) &&
      haveValue(cookies?.invitationToken)
    ) {
      navigate("/tenant/auth");
    }
  }, [cookies?.requestProfileLink, cookies?.invitationToken]);

  useEffect(() => {
    if (haveValue(workspace_slug) || haveValue(workspaceUuid)) {
      getWorkspaceDetailsFromSlug(workspace_slug, workspaceUuid)
        .then((res) => {
          const data = res.data;
          if (data.status == "Success") {
            if (
              data?.data?.customLinkEnabled &&
              haveValue(data?.data?.customLinkSlug)
            ) {
              navigate(`/oauth/${data?.data?.customLinkSlug}`);
              if (
                localStorage.getItem("usertype") == "tenant" &&
                haveValue(data?.data?.landlord_id)
              ) {
                setCookie(
                  "requestProfileLink",
                  `${data?.data?.landlord_id}_${data?.data?.uuid}`,
                  {
                    path: "/",
                    maxAge: 604800,
                  }
                );
              }
              setCompanyLogo(data?.data?.invitationLogo);
            } else {
              if (haveValue(data?.data?.invitationLogo)) {
                setCompanyLogo(data?.data?.invitationLogo);
              }
              const url = new URL(window.location.href);
              url.searchParams.delete("wid");

              window.history.replaceState(
                {},
                document.title,
                url.pathname + url.search
              );
            }
            if (data?.data?.catella_rules_activated) {
              setCookie("catellaWorkspaceTenant", `${data?.data?.uuid}`, {
                path: "/",
                maxAge: 3600,
              });
            }
            if (data?.data?.libeen_rules_activated) {
              setCookie("libeenWorkspaceTenant", `${data?.data?.uuid}`, {
                path: "/",
                maxAge: 3600,
              });
            }
            if (data?.data?.dea_rules_activated) {
              setCookie("deaWorkspaceTenant", `${data?.data?.uuid}`, {
                path: "/",
                maxAge: 3600,
              });
            }
          }
        })
        .catch((err) => {
          console.log(err, "Error in getWorkspaceDetailsFromSlug");
        });
    }
  }, [workspace_slug, workspaceUuid]);

  //Useffect for linkedin login and register
  useEffect(() => {
    if (logincode) {
      setLoading(true);
      let user_type = localStorage.getItem("usertype");
      if (!user_type) {
        toast.error(_t("pleaseSelectYourUserType"));
      } else {
        axios
          .get(
            `${
              process.env.REACT_APP_SERVER_URL
            }/users/linkedin-login/${logincode}?usertype=${user_type}&user_type=${
              window.location.hostname == "alquilatuhogar.skortorent.com"
                ? constants.MACC
                : constants.SKOR
            }`,
            {
              headers: {
                "Accept-Language": localStorage.getItem("i18nextLng"),
              },
            }
          )
          .then(async (res) => {
            let serverResponse = res;
            localStorage.setItem("token", serverResponse.data.token);
            localStorage.setItem("is_verified", true);
            toggleLogin(true);
            await loadUser(user_type);
            setLoading(false);

            if (
              haveValue(cookies.sharedProfileLink) &&
              user_type == "landlord"
            ) {
              if (haveValue(res?.data?.user?._id)) {
                shareProfile(
                  cookies.sharedProfileLink,
                  res?.data?.user?._id,
                  "null",
                  "full",
                  { shareType: "tLink" }
                )
                  .then((res) => {
                    removeCookie("sharedProfileLink", {
                      path: "/",
                      maxAge: 1800,
                    });
                  })
                  .catch((err) => {
                    console.log(err);
                  });
              }
            }
            // if (
            //   haveValue(cookies.requestProfileLink) &&
            //   user_type == "tenant"
            // ) {
            //   if (haveValue(res?.data?.user?._id)) {
            //     if (res?.data?.user?.docSigned == "COMPLETED") {
            //       shareProfile(
            //         res?.data?.user?._id,
            //         cookies.requestProfileLink,
            //         "null",
            //         "full",
            //         { shareType: "lLink" }
            //       )
            //         .then((res) => {
            //           removeCookie("requestProfileLink", {
            //             path: "/",
            //             maxAge: 1800,
            //           });
            //         })
            //         .catch((err) => {
            //           console.log(err);
            //         });
            //     } else {
            //       navigate("/profile-shared?agreement=true");
            //     }
            //   }
            // }

            if (localStorage.getItem("usertype") == "tenant") {
              navigate("/tenant");
            } else {
              navigate("/profile-request");
            }
          })
          .catch((err) => {
            setLoading(false);
            navigate("/auth");
            toast.error(_t("pleaseSignUpFirstUsingLinkedin"));
          });
      }
    }
  }, [logincode]);

  useEffect(() => {
    const useeffectFunc = async () => {
      if (
        haveValue(queryParameters.get("lng")) &&
        queryParameters.get("lng") == "es"
      ) {
        await i18next.changeLanguage("es");
        setCurrentLang("es");
      } else if (
        haveValue(localStorage.getItem("i18nextLng")) &&
        localStorage.getItem("i18nextLng") == "es"
      ) {
        await i18next.changeLanguage("es");
        setCurrentLang("es");
      } else if (
        haveValue(localStorage.getItem("i18nextLng")) &&
        localStorage.getItem("i18nextLng") == "en-us"
      ) {
        await i18next.changeLanguage("en-us");
        setCurrentLang("en-us");
      } else {
        await i18next.changeLanguage("es");
        setCurrentLang("es");
      }

      if (hash === "#tenant") {
        setUserType("tenant");
        setUserLogin((prev) => ({
          ...prev,
          checkedLandlord: false,
          checkedTenant: true,
          type: "tenant",
        }));
      } else if (hash === "#landlord") {
        setUserType("landlord");
        setUserLogin((prev) => ({
          ...prev,
          checkedLandlord: true,
          checkedTenant: false,
          type: "landlord",
        }));
      } else if (hash === "#guarantor") {
      } else {
        setUserType("tenant");
        setUserLogin((prev) => ({
          ...prev,
          checkedLandlord: false,
          checkedTenant: true,
          type: "tenant",
        }));
      }
    };

    useeffectFunc();
  }, []);

  const saveCookieInStateThing = () => {
    if (
      haveValue(cookies.requestProfileLink) &&
      localStorage.getItem("usertype") == "tenant"
    ) {
      setUserLogin((prev) => ({
        ...prev,
        qrCode_signup: true,
        requestProfileLink: haveValue(cookies.requestProfileLink)
          ? cookies.requestProfileLink
          : null,
      }));
    } else {
      console.log("cookie not found, or user type not found");
    }
  };

  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  useEffect(() => {
    if (isClient) {
      setTimeout(() => {
        saveCookieInStateThing();
      }, 2000);
    }
  }, [isClient]);

  useEffect(() => {
    saveCookieInStateThing();
  }, [cookies?.requestProfileLink]);

  useEffect(() => {
    let token = localStorage.getItem("token");
    let is_verified = localStorage.getItem("is_verified");
    let user_type = localStorage.getItem("usertype");
    if (token && is_verified) {
      toggleLogin(true);
      loadUser(user_type);
      if (user_type == "tenant") {
        navigate("/tenant");
      } else {
        navigate("/profile-request");
      }
    }
  }, [toggleLogin, navigate]);

  /**
   * ***************************************************************
   * Handle Language
   * ***************************************************************
   */
  const handleLanguageChange = async (langVal) => {
    await i18next.changeLanguage(langVal);
    await changeUserLng();
    setCurrentLang(langVal);
  };

  /**
   * ***************************************************************
   *  Handle User Type (Tenant/Landlord)
   * ***************************************************************
   */
  const handleUsertypeFromUrl = (newType) => {
    setUserType(newType);
    setUserLogin((prev) => ({
      ...prev,
      checkedLandlord: newType === "landlord",
      checkedTenant: newType === "tenant",
      type: newType,
    }));
  };

  const cardData = [
    {
      id: 1,
      img: "/images/kyc.svg",
      title: _t("tenant"),
      description: _t("createSkorShareWithLandlordAgentForEasyPropertyRenting"),
      type: "tenant",
    },
    {
      id: 2,
      img: "/images/home.svg",
      title: _t("landlordAgent"),
      description: _t("easilyRentYourPropertyToASecureAndTrustedTenant"),
      type: "landlord",
    },
    {
      id: 3,
      img: "/images/guarantor.svg",
      title: _t("guarantor"),
      description: _t("helpYourLovedOneSecureTheirDreamApartment"),
      type: "guarantor",
    },
  ];

  return (
    <div className="select-role-main">
      <img
        src={Logo}
        alt="Skor Logo"
        className="skor-logo"
        style={{ height: "3.0556vw" }}
      />
      {currentLang == "es" ? (
        <div
          className="language-switch-container language-switch-container-es  cursor-pointer"
          onClick={(e) => handleLanguageChange("en-us")}
        >
          <p>ES</p>
          <img className="flag-image" alt="Flag" src="/images/spain-flag.png" />
        </div>
      ) : (
        <div
          className="language-switch-container cursor-pointer"
          onClick={(e) => handleLanguageChange("es")}
        >
          <img className="flag-image" alt="Flag" src={Flag} />
          <p>EN</p>
        </div>
      )}
      <h1>{_t("welcomeToSkor")}</h1>
      <p>{_t("loginAs")}:</p>
      <div className="d-flex justify-content-center card-wrapper">
        {cardData.map((item) => (
          <div
            className={`user-type-card ${
              selectedType === item.type ? "selected-card" : ""
            }`}
            key={item.id}
            onClick={() => setSelectedType(item.type)}
          >
            <img src={item.img} alt={item.title} />
            <h2>{item.title}</h2>
            <p>{item.description}</p>
          </div>
        ))}
      </div>
      <button
        className="getStartedButton"
        onClick={() => navigate(`/${selectedType}/auth`)}
      >
        {_t("getStarted")}
      </button>
    </div>
  );
};

export default SelectUserType;
